import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import ProductSave from '~/components/UI/ProductHeader/ProductSetDetails/ProductSave'
import { ProductHeaderProps } from '~/components/UI/ProductHeader/types'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

type ProductSetsDetailsProps = {
  className?: string
  productDiscount?: ProductHeaderProps['productDiscount']
  setInformations?: ProductHeaderProps['setInformations']
}

export function ProductSetDetails({
  className,
  productDiscount,
  setInformations,
}: ProductSetsDetailsProps) {
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  return (
    <div className={cx(className, css.ProductSetDetails)}>
      {/* Display discount component if there is a discount number */}
      {productDiscount && (
        <ProductSave className={cx(css.productSave)} value={productDiscount} />
      )}

      {setInformations?.length > 0 && (
        <div className={css.setItems}>
          {setInformations.map((setInformation, index) => (
            <p key={index} className={cx(textStyle, css.setItem)}>
              {setInformation?.title && <span>{setInformation?.title}</span>}
              {setInformation?.variantTitle && (
                <span>{setInformation?.variantTitle}</span>
              )}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}
